import { Bookmark } from '../../../../../../mads';

import { colors } from '@indeed/ifl-tokens'

export interface SaveJobButtonIconProps {
    isSaved: boolean;
}

export function SaveJobButtonIcon(props: SaveJobButtonIconProps): React.JSX.Element {
    const { isSaved } = props;
    return isSaved ? (
        <Bookmark variant="filled" color={colors.foreground.strong} />
    ) : (
        <Bookmark variant="stroke" color={colors.foreground.strong} />
    );
}
